module.exports = __webpack_public_path__ + "img/icon-info.c8e3b4df.svg";